/* eslint-disable i18next/no-literal-string -- css not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const tabs = defineSlotRecipe({
  slots: ['root', 'list', 'trigger', 'content', 'indicator'],
  className: 'chakra-tabs',
  base: {
    list: {
      color: 'gray.muted',
    },
    trigger: {
      fontWeight: 'semibold',
      _active: { color: 'blue.500' },
      _selected: { color: 'blue.500' },
    },
    content: {
      '--tabs-content-padding': 'var(--chakra-spacing-8)',
      paddingX: 0,
      paddingTop: 8,
      paddingBottom: 2,
      _dark: {
        paddingTop: 2,
      },
    },
  },

  variants: {
    variant: {
      line: {
        list: {
          borderColor: 'transparent',
        },
        trigger: {
          _selected: {
            color: 'blue.solid',
          },
        },
      },

      // Previously shadow-rounded
      subtle: {
        trigger: {
          borderRadius: 'full',
          color: 'fg.muted',
          _selected: {
            bg: 'white',
            color: 'blue.solid',
            boxShadow: 'var(--chakra-shadows-md)',
          },
        },
      },

      // Previously solid-rounded
      enclosed: {
        list: {
          bg: 'none',
          border: '1px solid',
          borderColor: 'gray.300',
          padding: '2',
          borderRadius: 'full',
          marginBottom: '4',
          _dark: {
            bg: 'gray.100',
            boxShadow: '0px 0px 4px 0px {colors.blackAlpha.200} inset',
            border: 'none',
            width: 'full',
          },
        },
        trigger: {
          justifyContent: 'center',
          color: 'blue.solid',
          borderRadius: 'full',
          _selected: {
            bg: 'gray.700',
            color: 'white',
            shadow: 'none',
            boxShadow: 'sm',
          },
          _dark: {
            color: 'fg.muted',
            _selected: {
              bg: 'white',
              color: 'fg.muted',
            },
            _active: {
              color: 'fg.muted',
            },
          },
        },
        indicator: {
          _dark: {
            display: 'none',
          },
        },
      },
    },
    size: {
      lg: {
        root: {
          '--tabs-height': 'sizes.10',
          '--tabs-content-padding': 'spacing.4.5',
        },
        trigger: {
          py: '2',
          px: '4',
          textStyle: 'md',
          height: 'unset',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'line',
    size: 'lg',
  },
});
